import { Tabs, Tab, Box } from '@mui/material'

const ExpensesTabs = ({ expensesKeys, selectedKey, onExpensesTabsChange }) => {
  const tabStyle = {
    marginTop: '20px',
    marginBottom: '10px',
    borderBottom: '1.5px solid #143a5f',
    '& .MuiButtonBase-root': { fontSize: '15px', whiteSpace: 'nowrap' },
    '& .MuiTabs-scrollButtons svg': { fontSize: '3rem' },
    '.MuiTabs-scrollButtons.Mui-disabled': { opacity: '0.3' },
    '& .Mui-selected': { fontWeight: 'bold' },
  }

  const handleChange = (event, newValue) => {
    onExpensesTabsChange(newValue)
  }

  return (
    <Box display="flex">
      <Tabs
        value={selectedKey === 0 ? selectedKey : false}
        onChange={handleChange}
        sx={{
          minWidth: '140px',
          ...tabStyle,
          '& .MuiButtonBase-root': { fontSize: '19px' },
        }}
      >
        {/* First tab is the Overview */}
        <Tab key={0} value={0} label={<div>VUE GLOBALE</div>} />
      </Tabs>
      <Tabs
        value={selectedKey === 0 ? false : selectedKey}
        onChange={handleChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={tabStyle}
      >
        {expensesKeys
          ? expensesKeys.map((expenseKey, index) => (
              <Tab
                key={expenseKey.id}
                value={expenseKey.id}
                label={
                  <>
                    <div>{expenseKey.name}</div>
                    <div style={{ fontSize: '13px' }}>
                      {expenseKey.fees} Tantièmes
                    </div>
                  </>
                }
              />
            ))
          : null}
      </Tabs>
    </Box>
  )
}

export default ExpensesTabs
